// extracted by mini-css-extract-plugin
export default {"off":"StatusIcon_off__yeC5G","container":"StatusIcon_container__R3l+O","noMargin":"StatusIcon_noMargin__fP5xi","img":"StatusIcon_img__T0BGs"};